import { render, staticRenderFns } from "./Equipa.vue?vue&type=template&id=249d0a92&"
import script from "./Equipa.vue?vue&type=script&lang=js&"
export * from "./Equipa.vue?vue&type=script&lang=js&"
import style0 from "./Equipa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports